export * from "modules/AppointmentDetails/components/VehicleTyres/components/TyreTable/components/TyreReplacementTableRow/components/TyreActions/components/ConnectInterventionModal/hooks/useLinkReplacementMutation";
